export default "__VITE_ASSET__BwvSr4WM__"